import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  navigationList: {
    paddingBottom: '130px',
  },
});
